import React from "react";
import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import DocumentoPDF from "./DocumentoPDF";

const getAssetUrl = (asset) => {
  const url = asset?.fields?.file?.url || asset?.url;
  return url ? (url.startsWith("http") ? url : `https:${url}`) : null;
};

const ListadoPDF = ({ titulo, documentos = [] }) => (
  <Box sx={{ width: "100%", minWidth: 0, px: { xs: 2, md: 3 } }}>
    {titulo && (
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700, color: "#0b1f33" }}>
        {titulo}
      </Typography>
    )}
    {documentos.length ? (
      <Stack spacing={2}>
        {documentos.map((documento, index) => {
          const fields = documento?.fields || documento || {};
          return (
            <DocumentoPDF
              key={documento?.sys?.id || fields.id || index}
              titulo={fields.titulo || fields.title || "Documento PDF"}
              pdf={getAssetUrl(fields.pdf) || fields.link || null}
              fechaPublicacion={fields.fechaPublicacion || fields.fecha || null}
            />
          );
        })}
      </Stack>
    ) : (
      <Typography color="text.secondary">No hay documentos disponibles.</Typography>
    )}
  </Box>
);

ListadoPDF.propTypes = {
  titulo: PropTypes.string,
  documentos: PropTypes.array,
};

export default ListadoPDF;
